import { z } from 'zod';
// Define the common schema

const restrictedDomains = ['facebook.com', 'tiktok.com', 'instagram.com', 'clairebelton'];
const checkIsStoreFront = (url: string) => {
	const regex = /https?:\/\/(www.)?(walmart.[a-z.]{2,}|amazon.[a-z.]{2,})\/(cp|stores)\/[^\s]+/;

	return regex.test(url);
};

const getUrlValidationSchema = (tab: number) => {
	if (tab == 2 || tab == 3) {
		return z
			.array(
				z.string().nonempty({ message: ' URL is required' }).url({ message: 'Invalid URL format' })
			)
			.nonempty({ message: ' At least one URL is required' });
	} else if (tab == 1) {
		return z
			.array(
				z
					.string()
					.nonempty({ message: ' URL is required' })
					.url({ message: ' Invalid URL format' })
					.refine((url) => checkIsStoreFront(url), {
						message: ' is invalid'
					})
					.refine((url) => !restrictedDomains.some((domain) => url.includes(domain)), {
						message:
							' You are currently not subscribed to this marketplace. For more information on how to access this, please contact your CounterFind Account Manager. '
					})
			)
			.nonempty({ message: 'At least one URL is required' });
	} else if (tab != 1) {
		return z
			.array(
				z
					.string()
					.nonempty({ message: 'URL is required' })
					.url({ message: ' Invalid URL format' })
					.refine((url) => !checkIsStoreFront(url), {
						message: ' url can not be Storefront url'
					})
					.refine((url) => !restrictedDomains.some((domain) => url.includes(domain)), {
						message:
							' You are currently not subscribed to this marketplace. For more information on how to access this, please contact your CounterFind Account Manager. '
					})
			)
			.nonempty({ message: ' At least one URL is required' });
	} else {
		return z
			.array(
				z
					.string()
					.nonempty({ message: 'URL is required' })
					.url({ message: ' Invalid URL format' })
					.refine((url) => !restrictedDomains.some((domain) => url.includes(domain)), {
						message:
							' You are currently not subscribed to this marketplace. For more information on how to access this, please contact your CounterFind Account Manager. '
					})
			)
			.nonempty({ message: ' At least one URL is required' });
	}
};

const getCommonSchema = (tab: number) => {
	return z.object({
		full_name: z.string().min(1, { message: 'Name is required' }),
		country: z.object({
			label: z.string().optional(),
			value: z.string().optional()
		}).nullable().optional(),
		description: z.string(),
		url: getUrlValidationSchema(tab),
		email: z.string().email('Email is invalid').or(z.literal('')).optional(),
		business_name: z.string().optional(),
		address: z.string().optional(),
		city: z.string().optional(),
		state: z.string().optional(),
		zip: z.string().optional()
	});
};

const conditionalSchema = z.object({
	website: z.array(z.string()).optional(),
	facebook: z.array(z.string()).optional(),
	storeFront: z.array(z.string()).optional(),
	instagram: z.array(z.string()).optional()
});

export const getSchema = (isEdit: boolean, tab: number): z.ZodObject<any, any> => {
	const commonSchema = getCommonSchema(tab);
	return !isEdit ? commonSchema : commonSchema.merge(conditionalSchema);
};

let initialization = {
	full_name: '',
	url: [''] as [string, ...string[]],
	country: { label: '', value: '' },
	description: '',
	website: [''] as [string, ...string[]],
	email: '',
	business_name: '',
	address: '',
	city: '',
	state: '',
	zip: ''
};

export const getInitialization = (isEdit: boolean) => {
	return !isEdit
		? initialization
		: {
				storeFront: [''] as [string, ...string[]],
				facebook: [''] as [string, ...string[]],
				instagram: [''] as [string, ...string[]],
				...initialization
			};
};
export type FormSchema = ReturnType<typeof getSchema>;

// export type FormSchema = typeof schema;
